import template from './executivesummary.html';
import controller from './executivesummary.controller';
import './executivesummary.styl';

let executivesummaryComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default executivesummaryComponent;


// WEBPACK FOOTER //
// ./client/app/common/reports/executivesummary/executivesummary.component.js